module.exports = "/_next/static/images/dlya-dach-720a2866432b768f247288f65d20818c.svg";